export enum SandboxTypeEnum {
  E2B = 'E2B'
}
